import { HotelAvailabilityEmit, HotelAvailabilityResponseDTO } from '@bandido/shared/dtos';


export type HotelAndHistories = HotelAvailabilityEmit & Partial<{ historiesIds: number[], finalPrice: number, searchId: string }>;

/**
 * Updates a collection of hotel availability record based on new data.
 *
 * - If an hotel with the same `id` does not exist in the original array, it is added to the end.
 * - If an hotel with the same `id` exists, its price is updated only if the new price is lower.
 *
 * @param currentHotels - The original collection of hotel availability records.
 * @param newHotels - The new collection of hotel availability records to be merged.
 * @returns A new array with the updated collection.
 */
export function updateHotelAvailabilityRecords(
  currentHotels: HotelAndHistories[],
  newHotels: HotelAndHistories[]
): HotelAndHistories[] {
  const itemMap = new Map<number, HotelAndHistories>();

  currentHotels.forEach(hotel => itemMap.set(hotel.nimbuxHotelId!, hotel));
  newHotels.forEach(hotel => {
    const existingHotel = itemMap.get(hotel.nimbuxHotelId!);

    if (!existingHotel) {
      hotel.historiesIds = [hotel.searchHistoryId];
      itemMap.set(hotel.nimbuxHotelId!, hotel);
    } else if (hotel.minPrice < existingHotel.minPrice) {
      existingHotel.minPrice = hotel.minPrice;
      existingHotel.historiesIds?.push(hotel.searchHistoryId);
      itemMap.set(hotel.nimbuxHotelId!, existingHotel);
    } else {
      existingHotel.historiesIds?.push(hotel.searchHistoryId);
      itemMap.set(hotel.nimbuxHotelId!, existingHotel);
    }
  });

  return Array.from(itemMap.values());
}
